import {useFetchData} from 'hooks/api/useFetchData'
import {Group} from 'types/api/groups/group'

export const useFetchGroups = () => {
  const path = '/api/groups'
  return useFetchData<Group[]>(path, [], {})
}
